import { z } from "zod";

export const ProfessionSchema = z.enum([
  "occupational_therapist",
  "physical_therapist",
  "physical_therapist_assistant",
  "speech_therapist",
  "wellness_therapist",
]);
export type Profession = z.infer<typeof ProfessionSchema>;
